/**axios封装
 * 请求拦截、相应拦截、错误统一处理
 */
import axios from 'axios';
import QS from 'qs';
import { Message } from 'element-ui';
import store from '../store/index'
import router from '../router'

// 环境的切换
// axios.defaults.baseURL = '/api';
//  else if (process.env.NODE_ENV == 'debug') {
//   axios.defaults.baseURL = '';
// } else if (process.env.NODE_ENV == 'production') {
//   axios.defaults.baseURL = 'http://api.123dailu.com/';
// }
const tjuid = GetUrlParam('tjuid')

if (process.env.NODE_ENV == 'production') {
  axios.defaults.baseURL = 'https://www.tuanyun99.com/wxoms/app/'
  // axios.defaults.baseURL = 'http://www.test.com/wxoms/app/'
} else if (process.env.NODE_ENV == 'development') {
  axios.defaults.baseURL = '/api';
}

axios.defaults.withCredentials = true
// axios.defaults.crossDomain = true
// 请求超时时间
axios.defaults.timeout = 20000;


// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
axios.defaults.headers.post['vue'] = '1';
axios.defaults.headers.post['X-Requested-With'] = 'xmlhttprequest';
axios.defaults.headers.post['tjuid'] = tjuid || '';

//请求头Axios.create创建之前做判断，拿到接口中配置的属性，设置请求头为config.headers={'Content-Type': options.ContentType}

// 请求拦截器
axios.interceptors.request.use(
  config => {
    const token = store.state.Authorization;
    token && (config.headers.XTOKIN = token);
    return config;
  },

)

// 响应拦截器
axios.interceptors.response.use(
  response => {
    // 未登录情况
    if (response.data.errno == 5001) {
      return router.replace({
        path: '/login',
        query: { redirect: router.currentRoute.fullPath }
      });
    }
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况    
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 401: 未登录                
        // 未登录则跳转登录页面，并携带当前页面的路径                
        // 在登录成功后返回当前页面，这一步需要在登录页操作。                
        case 500:

          break;

        default:
          Message({
            message: error.response.data.message,
          });
      }
      return Promise.reject(error.response);
    }
  }
);
/** 1
 * get方法，对应get请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export async function get (url, params) {
  if (process.env.NODE_ENV == 'production') {
    if (store.state.i) {
      url += '&i=' + store.state.i
    } else {
      let res = await getI()
      if (res.errno == 0) {
        store.commit('setI', res.uniacid)
        store.commit('setUpUrl')
      }
      url += '&i=' + store.state.i
    }
  } else if (process.env.NODE_ENV == 'development') {
    store.commit('setI', 2)
    url += '&i=' + store.state.i
  }
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

/** 
 * post方法，对应post请求 
 * @param {String} url [请求的url地址] 
 * @param {Object} params [请求时携带的参数] 
 */
export async function post (url, params) {
  if (process.env.NODE_ENV == 'production') {
    if (store.state.i) {
      url += '&i=' + store.state.i
    } else {
      let res = await getI()
      if (res.errno == 0) {
        store.commit('setI', res.uniacid)
        store.commit('setUpUrl')
      }
      url += '&i=' + store.state.i
    }
  } else if (process.env.NODE_ENV == 'development') {
    store.commit('setI', 2)
    url += '&i=' + store.state.i
  }

  return new Promise((resolve, reject) => {
    axios.post(url, QS.stringify(params))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data)
      })
  });
}

let blockingUp = true
function getI () {
  if (blockingUp) {
    blockingUp = false
    return new Promise((resolve, reject) => {
      axios.post('wxl_oms_api.php?getwebapi=1&getapi=1', QS.stringify({
        bindhost: location.origin
      })).then(res => {
        resolve(res.data);
      })
        .catch(err => {
          reject(err.data)
        })
    });
    // axios.post('wxl_oms_api.php?getwebapi=1&getapi=1', QS.stringify({ bindhost: location.origin }))
    //
  } else {
    return new Promise((resolve, reject) => {
      let inter = setInterval(resolve, 500, () => {
        if (store.state.i) {
          clearInterval(inter)
          return { errno: 1 }
        }
      });
    });

  }

}
function GetUrlParam (paraName) {
  var url = document.location.toString();
  var arrObj = url.split("?");
  if (arrObj.length > 1) {
    var arrPara = arrObj[1].split("&");
    var arr;
    for (var i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");

      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  }
  else {
    return "";
  }
}
// Label Switched Path